export default class megaMenu {

    constructor() {
        this.settings = {
            mainMenu: document.getElementById('main-navigation'),
            megaMenuItems: document.querySelectorAll('.navigation__nav-item--mega-menu'),
            primaryMenuItems: document.querySelectorAll('.navigation__nav-item--primary'),
            activeClass: "is-active",
            bodyClass: "mega-menu-open"
        };

        this.activeMenuItem = null;
    }

    init() {
        if (this.settings.mainMenu) {
            this.setInitialActiveState();
            this.setInitialMegaMenuActiveStates();
            this.bindUIActions();
        }
    }

    setInitialActiveState() {
        const { primaryMenuItems } = this.settings;

        if (primaryMenuItems.length > 0) {
            const firstMenuItem = primaryMenuItems[0];
            const dataLink = firstMenuItem.getAttribute("data-link");

            if (dataLink) {
                const targetMegaMenuItem = document.getElementById(dataLink);
                firstMenuItem.classList.add(this.settings.activeClass);

                if (targetMegaMenuItem) {
                    targetMegaMenuItem.classList.add(this.settings.activeClass);
                }

                this.activeMenuItem = firstMenuItem;
            }
        }
    }

    setInitialMegaMenuActiveStates() {
        const { megaMenuItems, activeClass } = this.settings;

        megaMenuItems.forEach(megaMenu => {
            const firstPrimaryItem = megaMenu.querySelector('.navigation__nav-item--primary');

            if (firstPrimaryItem) {
                firstPrimaryItem.classList.add(activeClass);

                const dataLink = firstPrimaryItem.getAttribute("data-link");
                if (dataLink) {
                    const linkedMegaMenuItem = document.getElementById(dataLink);
                    if (linkedMegaMenuItem) {
                        linkedMegaMenuItem.classList.add(activeClass);
                    }
                }
            }
        });
    }

    resetToInitialState() {
        // Clear all active items
        this.deactivateMenuItems();
        // Reset to initial states
        this.setInitialActiveState();
        this.setInitialMegaMenuActiveStates();
    }

    bindUIActions() {
        const { primaryMenuItems, megaMenuItems } = this.settings;

        // Handle primary menu item hover
        primaryMenuItems.forEach(menuItem => {
            menuItem.addEventListener("mouseenter", () => {
                const dataLink = menuItem.getAttribute("data-link");
                this.activateMenuItems(menuItem, dataLink);
            });
        });

        // Add reset behavior to megaMenuItems
        megaMenuItems.forEach(megaMenu => {
            const link = megaMenu.querySelector('a');

            if (link) {
                link.addEventListener('mouseenter', () => {
                    document.body.classList.add(this.settings.bodyClass);
                    link.setAttribute('aria-expanded', 'true');
                });
            }

            megaMenu.addEventListener("mouseleave", () => {
                document.body.classList.remove(this.settings.bodyClass);
                if (link) {
                    link.setAttribute('aria-expanded', 'false');
                }
                this.resetToInitialState();
            });
        });
    }

    activateMenuItems(primaryMenuItem, dataLink) {
        if (!dataLink) return;

        const targetMegaMenuItem = document.getElementById(dataLink);

        if (this.activeMenuItem && this.activeMenuItem !== primaryMenuItem) {
            this.deactivateMenuItems();
        }

        primaryMenuItem.classList.add(this.settings.activeClass);

        if (targetMegaMenuItem) {
            targetMegaMenuItem.classList.add(this.settings.activeClass);
        }

        this.activeMenuItem = primaryMenuItem;
    }

    deactivateMenuItems() {
        document.querySelectorAll(`.${this.settings.activeClass}`).forEach(activeItem => {
            activeItem.classList.remove(this.settings.activeClass);
        });

        this.activeMenuItem = null;
    }
}
